import { createContext } from 'react';
import type { WalletContextType } from './WalletContext.types';

const WalletContext = createContext<WalletContextType | null>(null);

export default WalletContext;

